// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__ZhOrf","title":"styles_title__3IdE8"};